import prettyBytes from "pretty-bytes"

export const useFileUploadValidation = () => {
  const config = useRuntimeConfig()
  const { isSuperAdmin } = useAuthStore()
  const { t } = useI18n()

  const maxFiles = Number(config.public.MAX_FILES_IN_BATCH)
  const maxFileSize = Number(config.public.MAX_FILE_SIZE_IN_BYTES)

  const validateFilesUpload = (files: File[]): string | true => {
    if (isSuperAdmin) {
      return true
    }

    if (files.length > maxFiles) {
      return t("maxFiles", { max: maxFiles })
    }

    const oversizedFile = files.find((file) => file.size > maxFileSize)

    if (oversizedFile) {
      console.warn("oversizedFile", oversizedFile)
      return t("maxFileSize", {
        max: prettyBytes(maxFileSize),
      })
    }

    return true
  }

  return {
    validateFilesUpload,
  }
}
